/* eslint-disable */
/**
 * Vulnerability Component
 * Converted from jQuery to native JavaScript while preserving original behavior
 */

import { isEditModeFooter } from 'js/helpers.js';

class Vulnerability {

    constructor() {

        if (isEditModeFooter()) {
            // add wcmmode=disabled to the url and refresh the page
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('wcmmode', 'disabled');
            window.location.search = urlParams.toString();
            return;
        }

        const self = this;

        const elements = {
        };

        self.addEventListeners();
    }

    addEventListeners() {
    }
}

function hasNoLetters(str) {
    const regex = /[a-zA-Z]/;
    return !regex.test(str);
}

const vulnerability = document.querySelector('.vulnerability');
if (vulnerability) {
    new Vulnerability();

    const vulnerabilityDetail = document.querySelector(".vulnerability .vulnerability-full-detail__root");
    const documentId = vulnerabilityDetail?.dataset.documentId;
    const vulnerabilityName = vulnerabilityDetail?.dataset.vulnerabilityName;

    if (vulnerabilityName !== undefined) {
        const emailButton = document.querySelector('#email-page');
        if (emailButton) {
            emailButton.addEventListener('click', () => {
                const canonicalLink = document.querySelector('link[rel="canonical"]');
                const uri = canonicalLink?.getAttribute('href') || '';
                const catalogNumber = 'Vulnerability #: ' + documentId;
                const brand = 'Rockwell Automation';
                const body = vulnerabilityName + '\n' + catalogNumber + '\n' + uri + '\n';
                console.log(body);
                window.location.href = 'mailto:?subject=' + encodeURIComponent(brand + ' ' + vulnerabilityName) + '&body=' + encodeURIComponent(body);
            });
        }
    }

    const jsonLinks = document.querySelectorAll(".vulnerability .vulnerability-full-detail__root .vulnerability-full-detail__box-info-downloads-json a");
    jsonLinks.forEach(function(jsonLink) {
        const jsonLinkString = jsonLink.getAttribute("data-json-string");
        if (jsonLinkString) {
            const jsonLinkArray = jsonLinkString.split("=>");
            if (jsonLinkArray.length !== 2) {
                jsonLink.remove();
            } else {
                jsonLink.textContent = jsonLinkArray[0];
                jsonLink.setAttribute("href", jsonLinkArray[1]);
            }
        }
    });
}
